import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import {
  ReportActions,
  ReportDescription,
  ReportSection,
  ReportToggle,
  ReportToggleList
} from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

// report 03601
export function TournamentResultsIndividualParticipantSideReportForm(props: Props) {
  const requestInitial = {
    isShowBlank: true,
    isPrintFullNames: true
  };

  return (
    <Formik
      onSubmit={values => {
        props.onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_RESULTS_INDIVIDUAL_PARTICIPANT_SIDE);
      }}
      initialValues={requestInitial}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm highLevelTournamentReportForm">
          <div className="eReportForm__content">
            <ReportDescription>View individual tournament results for schools represented by your area.</ReportDescription>

            <ReportSection
              number={1}
              title="Report content"
              hint="Choose how incomplete results and student names should be displayed."
            >
              <ReportToggleList>
                <ReportToggle
                  name="isShowBlank"
                  label="Include participants without results"
                  hint="Show entered participants whose result has not yet been recorded."
                  value={values.isShowBlank}
                  onChange={value => setFieldValue('isShowBlank', value)}
                />
                <ReportToggle
                  name="isPrintFullNames"
                  label="Print full student names"
                  hint="When disabled, show the first name and only the initial of the surname."
                  value={values.isPrintFullNames}
                  onChange={value => setFieldValue('isPrintFullNames', value)}
                />
              </ReportToggleList>
            </ReportSection>
          </div>
          <ReportActions onCancel={props.onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}

